import React, { useEffect } from "react";
import { useRive, Layout, Fit, Alignment } from "@rive-app/react-canvas";

const CliLogin: React.FC = () => {
  useEffect(() => {
    document.title = "Logged In | Brev";
  }, []);

  const { RiveComponent } = useRive({
    src: "/rive/brev-hero-empty-text.riv",
    stateMachines: "State Machine 1",
    autoplay: true,
    layout: new Layout({
      fit: Fit.Contain,
      alignment: Alignment.Center,
    }),
  });

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",

        backgroundColor: "#0C0C0C",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
    >
      <div style={{ width: "min(500px, 80vw)", aspectRatio: "1" }}>
        <RiveComponent />
      </div>

      <div
        style={{
          textAlign: "center",
          marginTop: "2rem",
          display: "flex",
          flexDirection: "column",
          gap: "0.75rem",
        }}
      >
        <h1
          style={{
            color: "#76B900",
            fontSize: "1.75rem",
            fontWeight: 600,
            margin: 0,
          }}
        >
          You're logged in
        </h1>
        <p
          style={{
            color: "#C6C6C6",
            fontSize: "1.1rem",
            margin: 0,
          }}
        >
          You can close this window.
        </p>
        <p
          style={{
            color: "#888",
            fontSize: "0.95rem",
            margin: 0,
          }}
        >
          You may need to press{" "}
          <kbd
            style={{
              backgroundColor: "#27272a",
              color: "#C6C6C6",
              padding: "2px 8px",
              borderRadius: "4px",
              border: "1px solid #5e5e5e",
              fontFamily: "monospace",
              fontSize: "0.9rem",
            }}
          >
            Enter
          </kbd>{" "}
          in the CLI to continue.
        </p>
      </div>
    </div>
  );
};

export default CliLogin;
